import jwt from 'jwt-decode';
import PubSub from 'pubsub-js'
import dayjs from 'dayjs'
import { Capacitor } from '@capacitor/core';
import { GoogleAuth } from '@codetrix-studio/capacitor-google-auth';

import fetcher from '../services/fetcher';
import log from '../services/log';
import ga from '../services/ga';
import billing from '../services/billing';

const Auth = {
  getUser: () => {
    const token = localStorage.token;
    if (token){
      const user = jwt(token);
      //log.traceTag('auth.getUser', user)
      if (user) {
        return user;
      }
    }

    return null;
  },
  signIn: async (name, email, image) => {
    log.traceTag('signIn', image);
    const data = await fetcher.signInUser(name, email, image);
    console.log(data);
    // store token
    const user = jwt(data.token);
    //console.log(user);
    localStorage.setItem('token', data.token);
    PubSub.publish('LOGIN', 'signin');
    return Auth.getUser();
  },
  authAppleUser:  async (data) => {
    log.traceTag('apple signIn', data);
    const appleUserProfile = await fetcher.authAppleUser(data);
    log.traceTag('apple user profile', appleUserProfile);
    return appleUserProfile;
    /*console.log(response);
    // store token
    const user = jwt(response.token);
    //console.log(user);
    localStorage.setItem('token', response.token);
    PubSub.publish('LOGIN', 'signin');
    return Auth.getUser();*/
  },
  refreshUser: async () => {
    /*if (Capacitor.isNativePlatform()){
      return testUser;
    }*/

    const data = await fetcher.refreshToken(Auth.getUser().name, Auth.getUser().email)
    localStorage.setItem('token', data.token);
    PubSub.publish('REFRESH', 'refreshed');
    return Auth.getUser();
  },
  addToPortfolio: async (coin) => {
    ga.track({
      category: 'Retention',
      action: 'onPortfolioCoinAdded',
      label: coin
    })

    await fetcher.addToPortfolio(coin)
    return Auth.refreshUser()
  },
  removeFromPortfolio: async (coin) => {
    ga.track({
      category: 'Retention',
      action: 'onPortfolioCoinRemoved',
      label: coin
    })
    await fetcher.removeFromPortfolio(coin)
    return Auth.refreshUser()
  },
  logOut: () => {
    localStorage.removeItem('token');
    if (Capacitor.isNativePlatform()){
      GoogleAuth.signOut();
    }
    PubSub.publish('LOGOUT', 'signout');
    return;
  },
  isLogged: () => {
    const user = Auth.getUser()
    return (user != null);
  },
  setCountryCode: (value) => {
    localStorage.setItem('country', value);
  },
  getCountryCode: () => {
    return localStorage.getItem('country');
  },
  unsubscribe: async (email) => {
    const result = await fetcher.unsubscribe(email);
    PubSub.publish('UNSUB', 'unsubscribed');
    return result;
  },
  isFreeTrial: () => {
    const FREE_TRIAL_DAYS = 7;
    const user = Auth.getUser()
    if (user){
      //log.trace(user);
      const now = dayjs(new Date());
      const createdOn = dayjs(new Date(user.createdOn));

      // give free trial for free days
      if (createdOn &&
        createdOn.add(FREE_TRIAL_DAYS, 'day') > now) { 
        return true; 
      } else{
        return false;
      }
    } else {
      log.traceTag('auth', 'non logged user');
      // user is not signed, check the first visit date
      const now = dayjs();
      const firstVisit = localStorage.firstVisit;
      log.traceTag('localStorage.firstVisit', firstVisit);
      if (firstVisit){
        log.traceTag('auth', 'checking if first visit was earlier than trial days');
        var firstVisitDate = dayjs(+firstVisit);
        log.traceTag('firstVisitDate', firstVisitDate);
        log.traceTag('now', now);
        if (firstVisitDate &&
          firstVisitDate.add(FREE_TRIAL_DAYS, 'day') > now) { 
            log.traceTag('auth', 'still on trial');
            return true; 
        } else{
            log.traceTag('auth', 'trial expired');
            return false;
        }
      }

      // always on landing
      //return false;
    }
  },
  setFirstVisit:() => {
    const firstVisit = localStorage.firstVisit;
    if (!firstVisit){
      // set first visit date and return true 
      log.traceTag('auth', 'set first visit date');
      localStorage.setItem('firstVisit', dayjs().valueOf());
    }
  },
  isUnlocked: () => {
    return Auth.isFreeTrial() || Auth.isProMembership();
  },
  isStripeCustomer: () => {
    const user = Auth.getUser()
    log.traceTag('isStripeCustomer', user);
    return (user.customerId != null && user.customerId !== 'android' && user.customerId !== 'ios');
  },
  isAndroidCustomer: () => {
    const user = Auth.getUser()
    log.traceTag('isAndroidCustomer', user);
    return (user.customerId === 'android');
  },
  isIOSCustomer: () => {
    const user = Auth.getUser()
    log.traceTag('isIOSCustomer', user);
    return (user.customerId === 'ios');
  },
  isProMembership: () => {
    //return true;

    const user = Auth.getUser()
      if (user){
        /*if (user.email !== 'aershov24@gmail.com'){
          return true;
        }*/
      //log.trace(user);
      const now = new Date();
      const proUntilDate = new Date(user.proUntilDate);

      if (proUntilDate &&
        proUntilDate > now) { 
        //log.trace('isProMembership: true');
        return true;
    } else {
      // if user on mobile check if subscription is owned
      /*if (Capacitor.isNativePlatform()){
        const sub_1m_owned = billing.isOwned();
        log.traceTag('sub_1m owned', sub_1m_owned);
        return sub_1m_owned;
      }*/
      //log.trace('isProMembership: false');
      return false;
    }
    } else {
      return false;
    }
  },
  showUnlockDialog: (promocode) => {
    ga.track({
      category: 'Offer',
      action: 'onShowUnlockDialog'
    })

    PubSub.publish('UNLOCK_DIALOG', {action: 'show', promocode: promocode });
  },
  closeUnlockDialog: (_showSocialProof = true) => {
    //closeUnlockDialogEvent.next(true)
    PubSub.publish('UNLOCK_DIALOG', {action: 'close', showSocialProof: _showSocialProof });
  },
  showSettingsDialog: () => {
    ga.track({
      category: 'Offer',
      action: 'onShowUnlockDialog'
    })

    PubSub.publish('SETTINGS_DIALOG', {action: 'show' });
  },
  closeSettingsDialog: () => {
    PubSub.publish('SETTINGS_DIALOG', {action: 'close' });
  },
  proUnlocked: () => {
    ga.track({
      category: 'Revenue',
      action: 'proUnlocked'
    })
    log.traceTag('auth', 'proUnlocked');
    PubSub.publish('PRO', 'unlocked');
  },

}

export default Auth;
